import './Overlay.scss';
import { Spinner } from 'react-bootstrap';

export const Overlay = ({
    label
}: {
    label?: string;
}) => {
    return (
        <div className="overlay-comp">
            <div className="overlay-comp__content text-center">
                <Spinner />
                {label ? <div className="fw-light mt-3">{label}</div> : null}
            </div>
        </div>
    );
}